/**
 * Simple mouse drag-to-scroll for horizontal sliders
 */
class SliderDrag {
    constructor(element) {
        this.slider = element;
        this.isDown = false;
        this.startX = 0;
        this.scrollLeft = 0;

        this.init();
    }

    init() {
        this.slider.addEventListener('mousedown', (e) => {
            this.isDown = true;
            this.slider.classList.add('active');
            this.startX = e.pageX - this.slider.offsetLeft;
            this.scrollLeft = this.slider.scrollLeft;
            this.slider.style.scrollBehavior = 'auto'; // Disable smooth scroll while dragging
        });

        this.slider.addEventListener('mouseleave', () => {
            this.isDown = false;
            this.slider.classList.remove('active');
        });

        this.slider.addEventListener('mouseup', () => {
            this.isDown = false;
            this.slider.classList.remove('active');
            this.slider.style.scrollBehavior = 'smooth';
        });

        this.slider.addEventListener('mousemove', (e) => {
            if (!this.isDown) return;
            e.preventDefault();
            const x = e.pageX - this.slider.offsetLeft;
            const walk = (x - this.startX) * 2; // scroll-fast factor
            this.slider.scrollLeft = this.scrollLeft - walk;
        });
    }
}

// Observe for slider elements and apply drag
function initSliderDrag() {
    const sliders = document.querySelectorAll('.cart-drawer__recommendations .slider');
    sliders.forEach(slider => {
        if (!slider.dataset.dragInitialized) {
            new SliderDrag(slider);
            slider.dataset.dragInitialized = 'true';
        }
    });
}

// Initial call
initSliderDrag();

// Re-init when cart refreshed
if (typeof subscribe !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        setTimeout(initSliderDrag, 100);
    });
}

// Also observer for dynamically added sliders
const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
            initSliderDrag();
        }
    });
});

observer.observe(document.body, { childList: true, subtree: true });
